// Pure helpers computing dashboard/analytics figures from the already-fetched
// order list, so the admin dashboard shows real numbers without needing a
// dedicated backend analytics endpoint - this store's order volume is small
// enough that client-side aggregation is simpler and just as fast.

export const isCanceled = (order) => order.order_Status === 'Canceled';

export function revenueByDay(orders, days = 14) {
  const totals = {};
  orders.forEach((order) => {
    if (isCanceled(order)) return;
    const day = order.order_Placment_Date;
    if (!day) return;
    totals[day] = (totals[day] || 0) + Number(order.total_Amount || 0);
  });

  const sortedDays = Object.keys(totals).sort();
  const lastDays = sortedDays.slice(-days);
  return lastDays.map((day) => ({
    name: day.slice(5), // "MM-DD"
    Revenue: Number(totals[day].toFixed(2)),
  }));
}

export function ordersByStatus(orders) {
  const counts = {};
  orders.forEach((order) => {
    counts[order.order_Status] = (counts[order.order_Status] || 0) + 1;
  });
  return Object.entries(counts).map(([name, Orders]) => ({ name, Orders }));
}

export function summaryStats(orders) {
  const nonCanceled = orders.filter((o) => !isCanceled(o));
  const totalRevenue = nonCanceled.reduce((total, o) => total + Number(o.total_Amount || 0), 0);
  const totalOrders = nonCanceled.length;
  const averageOrderValue = totalOrders > 0 ? totalRevenue / totalOrders : 0;
  return { totalRevenue, totalOrders, averageOrderValue, canceledCount: orders.length - totalOrders };
}
